import { toast } from "sonner";
import { fmtDate } from "@/lib/api";

// Print roll-serial slips. Each serial prints as a group of 4 identical copies (2x2) on its own
// page, so all four can be cut along the dashed guides and stuck to each side of the box.
const COPIES_PER_SERIAL = 4;

export const printSerialSlips = (rows, meta = {}) => {
  if (!rows || !rows.length) return;
  const groups = rows
    .map((s) => {
      const product = s.product_name || s.variant || s.product_type || "";
      const studio = s.studio_name || meta.studioName || "";
      const accreditation = s.accreditation || meta.accreditation || "";
      const slip = `
        <div class="slip">
          <div class="brand">VELOSKIN PPF</div>
          <div class="ptype">${product}</div>
          <div class="serial">${s.serial}</div>
          <div class="cap">${s.total_capacity ? s.total_capacity + " sqft" : ""}</div>
          ${studio ? `<div class="studio">${studio}</div>` : ""}
          ${accreditation ? `<div class="accred accred-${accreditation === "Accredited" ? "yes" : "no"}">${accreditation} detailer</div>` : ""}
          <div class="date">${s.created_at ? fmtDate(s.created_at) : ""}</div>
        </div>`;
      return `
        <div class="group">
          <div class="ghead">${s.serial} &middot; ${COPIES_PER_SERIAL} copies &mdash; cut along dashed lines, one per box side</div>
          <div class="grid">${slip.repeat(COPIES_PER_SERIAL)}</div>
        </div>`;
    })
    .join("");
  const w = window.open("", "_blank");
  if (!w) return toast.error("Allow pop-ups to print slips");
  w.document.write(`<html><head><title>Roll serial slips</title><style>
    @page { size: A4; margin: 8mm; }
    body { margin:0; font-family:Arial,sans-serif; }
    .group { page-break-after: always; }
    .group:last-child { page-break-after: auto; }
    .ghead { font-size:10px; color:#555; margin-bottom:4mm; text-align:center; letter-spacing:1px; }
    .grid { display:grid; grid-template-columns:1fr 1fr; gap:0; }
    .slip { box-sizing:border-box; height:128mm; border:1.5px dashed #111; margin:0;
      padding:8mm 6mm; text-align:center; display:flex; flex-direction:column;
      align-items:center; justify-content:center; page-break-inside:avoid; }
    .brand { font-size:14px; letter-spacing:3px; color:#b91c1c; font-weight:bold; }
    .ptype { font-size:15px; font-weight:700; color:#111; margin-bottom:6px; }
    .serial { font-size:34px; font-weight:800; letter-spacing:2px; font-family:monospace; margin-top:4px; }
    .cap { font-size:16px; margin-top:8px; }
    .studio { font-size:13px; font-weight:600; color:#111; margin-top:10px; }
    .accred { font-size:11px; font-weight:700; letter-spacing:1px; text-transform:uppercase; margin-top:3px; }
    .accred-yes { color:#15803d; }
    .accred-no { color:#b45309; }
    .date { font-size:10px; color:#888; margin-top:6px; }
  </style></head><body onload="window.print()">${groups}</body></html>`);
  w.document.close();
};
